export const WISHLIST_ADD_ITEM = 'WISHLIST_ADD_ITEM';
export const WISHLIST_REMOVE_ITEM = 'WISHLIST_REMOVE_ITEM';
export const WISHLIST_UPDATE_ITEM = 'WISHLIST_UPDATE_ITEM';

